<template>
  <Modal :preventBackdrop="true" :hideExit="false" :breakLine="!isLastStep" @cancel="forceCloseModal" v-if="modalActive" mClass="flex-grow-1 d-flex flex-column height-unlimit" cClass="onboarding-container mw732" fClass="p-4 pt-3">
    <template #header>
      <h2 class="typo-heading20 typo-medium text-light-high" v-if="isLastStep">{{ onboarding.title }}</h2>
    </template>
    <template #default>
      <!-- <div> -->
      <div class="onboarding-body flex-grow-1 flex-column d-flex">
        <div class="video-step" v-if="currentStep && currentStep.video">
          <video v-if="loadedThumbnail" v-show="loadedVid" @loadeddata="videoLoaded" ref="video" class="" width="100%" height="auto" loop="true" preload="none" muted="false" playsinline autoplay="true" :src="currentStep.video">
            <source :src="currentStep.video" type="video/mp4" />
          </video>
          <Indicating v-show="!loadedVid" iClass="onboarding-indicating" size="large" />
          <img v-show="!loadedVid" @load="loadedThumbnail = true" alt="Gempages OnBoarding" title="Gempages OnBoarding" class="gp_lazyload" :class="{ gp_lazyloaded: loadedVid }" :src="currentStep.thumbnail" />
        </div>
        <div v-if="!isLastStep" class="last-step m-auto text-center">
          <p class="typo-h1 mb-1">{{ $t("generals.thankYou") }}</p>
          <p class="typo-paragraph14 typo-regular-150 text-light-low mb-3 mw339 m-auto">
            {{ currentStep.content }}
          </p>
          <div class="suggest-videos px-2" v-if="type == 'subpages'">
            <div class="row justify-content-center">
              <div v-for="(video, index) in videoList" :key="index" class="video-item col-6 mb-4">
                <div class="iframe-container">
                  <iframe :src="'https://www.youtube.com/embed/' + video.items[0].id + '?autoplay=0'" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
                </div>
                <h3 class="typo-button14 typo-medium text-light-high mt-1 text-left">{{ video.items[0].snippet.localized.title }}</h3>
              </div>
            </div>
          </div>
          <div class="btn-group justify-content-center">
            <a href="https://www.youtube.com/channel/UCRUP8zvEDtEJrRtqCjbLJ0w" target="_blank" class="btn btn-default btn-primary px-3 d-inline-flex">{{ $t("onboarding.exploreMore") }}</a>
            <button class="btn btn-default btn-secondary px-3 d-inline-flex" @click="continueStartedGuide">{{ $t("onboarding.continueStartedGuide") }}</button>
          </div>
        </div>
        <p class="typo-paragraph14 typo-regular-150 text-light-high p-4 pt-3 pb-0 step-content" v-if="isLastStep" v-html="currentStep.content"></p>
      </div>
      <div class="onboarding-footer d-flex justify-content-between">
        <div class="current-step d-flex justify-content-between pb-4 pl-4 d-flex align-items-end" v-if="isLastStep">
          <p class="typo-heading16 typo-medium text-light-low">
            {{ $t("onboarding.currentStep", { num1: currentStepIndex, num2: totalSteps }) }}
          </p>
        </div>
        <div class="btn-group onboarding-btn flex-row-reverse mt-3 pr-4 pb-4" v-if="isLastStep">
          <button class="btn btn-default btn-primary" @click="nextStep">{{ $t("generals.next") }}</button>
          <button class="btn btn-default btn-outline mr-1" @click="previousStep" v-if="currentStepIndex > 1">{{ $t("generals.previous") }}</button>
        </div>
      </div>
      <!-- </div> -->
    </template>
  </Modal>
</template>

<script>
import { Api, ApiUrl } from "@/services";
export default {
  name: "OnBoarding",
  props: {
    type: {
      type: String,
      default: "subpages"
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalActive: true,
      currentStepIndex: 1,
      list: ["STS2wK3uiVg", "zH8LZ5GaCaU"],
      videoList: [],
      loadedVid: false,
      loadedThumbnail: false
    };
  },
  computed: {
    totalSteps() {
      return this.onboarding.steps.length - 1;
    },
    onboarding() {
      let subpages = {
        title: this.$t("page.landingPages2"),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Landing+Pages/1.mp4",
            content: this.$t(`onboarding.${this.type == "subpages" ? "landingpages" : this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/subpages/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Landing+Pages/2.mp4",
            content: this.$t(`onboarding.${this.type == "subpages" ? "landingpages" : this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/subpages/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Landing+Pages/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/subpages/3.png")
          },
          {
            id: 4,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Landing+Pages/4.mp4",
            content: this.$t(`onboarding.${this.type}.content4`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/subpages/4.png")
          },
          {
            id: 5,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Landing+Pages/5.mp4",
            content: this.$t(`onboarding.${this.type}.content5`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/subpages/5.png")
          },
          {
            id: 6,
            content: this.$t(`onboarding.${this.type}.content6`)
          }
        ]
      };

      let articlepages = {
        title: this.$t("page.blog"),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Blog+Posts/1.mp4",
            content: this.$t(`onboarding.${this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/articlepages/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Blog+Posts/2.mp4",
            content: this.$t(`onboarding.${this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/articlepages/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Blog+Posts/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/articlepages/3.png")
          },
          {
            id: 4,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Blog+Posts/4.mp4",
            content: this.$t(`onboarding.${this.type}.content4`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/articlepages/4.png")
          },
          {
            id: 5,
            content: this.$t(`onboarding.${this.type}.content5`)
          }
        ]
      };

      let homepages = {
        title: this.$tc("page.homepages", 2),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Home+Pages/1.mp4",
            content: this.$t(`onboarding.${this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/homepages/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Home+Pages/2.mp4",
            content: this.$t(`onboarding.${this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/homepages/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Home+Pages/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/homepages/3.png")
          },
          {
            id: 4,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Home+Pages/4.mp4",
            content: this.$t(`onboarding.${this.type}.content4`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/homepages/4.png")
          },
          {
            id: 5,
            content: this.$t(`onboarding.${this.type}.content5`)
          }
        ]
      };

      let productpages = {
        title: this.$tc("page.productpages", 2),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Product+Pages/1.mp4",
            content: this.$t(`onboarding.${this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/productpages/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Product+Pages/2.mp4",
            content: this.$t(`onboarding.${this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/productpages/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Product+Pages/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/productpages/3.png")
          },
          {
            id: 4,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Product+Pages/4.mp4",
            content: this.$t(`onboarding.${this.type}.content4`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/productpages/4.png")
          },
          {
            id: 5,
            content: this.$t(`onboarding.${this.type}.content5`)
          }
        ]
      };

      let collectionpages = {
        title: this.$tc("page.collectionpages", 2),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Collection+Pages/1.mp4",
            content: this.$t(`onboarding.${this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/collectionpages/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Collection+Pages/2.mp4",
            content: this.$t(`onboarding.${this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/collectionpages/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Collection+Pages/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/collectionpages/3.png")
          },
          {
            id: 4,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Collection+Pages/4.mp4",
            content: this.$t(`onboarding.${this.type}.content4`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/collectionpages/4.png")
          },
          {
            id: 5,
            content: this.$t(`onboarding.${this.type}.content5`)
          }
        ]
      };

      let integrations = {
        title: this.$t("integration.title"),
        steps: [
          {
            id: 1,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Integrations/1.mp4",
            content: this.$t(`onboarding.${this.type}.content1`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/integration/1.png")
          },
          {
            id: 2,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Integrations/2.mp4",
            content: this.$t(`onboarding.${this.type}.content2`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/integration/2.png")
          },
          {
            id: 3,
            video: "https://dashboardv3-assets.s3-ap-southeast-1.amazonaws.com/Dashboardv3/OnBoarding-Videos/Integrations/3.mp4",
            content: this.$t(`onboarding.${this.type}.content3`),
            thumbnail: require("@/core/assets/Dashboardv3/Onboarding/Thumbnails/integration/3.png")
          },
          {
            id: 4,
            content: this.$t(`onboarding.${this.type}.content4`)
          }
        ]
      };

      let data = {
        subpages: subpages,
        articlepages: articlepages,
        homepages: homepages,
        productpages: productpages,
        collectionpages: collectionpages,
        integrations: integrations
      };

      return data[this.type];
    },
    currentStep() {
      return this.onboarding.steps.find(e => e.id == this.currentStepIndex);
    },
    lastStep() {
      return this.onboarding.steps.length - 1;
    },
    isLastStep() {
      return this.currentStepIndex <= this.lastStep;
    }
  },
  created() {
    for (let i = 0; i < this.list.length; i++) {
      Api.youtube.get(ApiUrl.youtube.video(this.list[i], "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo")).then(res => {
        this.videoList.push(res.data);
      });
    }
  },
  methods: {
    nextStep() {
      this.currentStepIndex++;
      this.loadedVid = false;
      this.loadedThumbnail = false;
    },
    previousStep() {
      this.currentStepIndex--;
      this.loadedVid = false;
      this.loadedThumbnail = false;
    },
    closeModal() {
      this.currentStepIndex = 1;
      this.modalActive = false;
      this.$emit("close");
    },
    forceCloseModal() {
      this.currentStepIndex = 1;
      this.modalActive = false;
      this.$emit("forceClose");
    },
    videoLoaded() {
      this.loadedVid = true;
    },
    continueStartedGuide() {
      this.$emit("continue");
    }
  }
};
</script>

<style lang="scss" scoped>
.video-step {
  overflow: hidden;
  min-height: 100px;
  max-height: 457px;
  video {
    width: calc(100% + 2px);
    transform: translateX(-1px);
  }
  .gp_lazyload {
    width: 100%;
    filter: blur(5px);
    &.gp_lazyloaded {
      filter: blur(0px);
    }
  }
  &-lazy {
    position: relative;
    .gfLoader {
      top: 0px;
    }
    // height: 100%;
  }
}

.onboarding-container {
  .last-step {
    // max-width: 504px;
    min-width: $onboardingLastStepMinWidth;
    padding-bottom: 50px;
    .video-item {
      // width: 240px;
      &:first-child {
        // margin-right: 24px;
      }

      .iframe-container {
        position: relative;
        padding-bottom: 56.25%;
        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // .onboarding-body {
  // }
  .onboarding-footer {
    // .current-step {
    // }
    .onboarding-btn {
      position: relative;
      button {
        min-width: 120px;
      }
    }
  }
}

.onboarding-indicating {
  position: absolute !important;
  left: 50%;
  top: calc(50% - 66px);
  transform: translate(-50%, -50%);
  z-index: 1;
}

@media (max-height: 734px) {
  .step-content {
    max-height: 90px;
    height: 20vh;
    overflow: auto;
    padding-top: 8px !important;
  }
}

@media (max-height: 671px) {
  .step-content {
    max-height: 90px;
    height: 12vh;
    overflow: auto;
  }
}
</style>

<style lang="scss">
.gp_modal .onboarding-container {
  max-height: 95vh;
}

@media (max-height: 734px) {
  .gp_modal .onboarding-container {
    width: 25%;
    min-width: $onboardingLastStepMinWidth;
  }
}
</style>
